import MessageList, { Message } from "@/components/message/message-list";
import MessageNav from "@/components/message/message-nav";
import { useChatSharedQuery } from "@/hooks/services/queries/ai-agent/use-chat-shared-query";
import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

const AiSharePage = () => {
  const { id } = useParams();
  const { data: messages } = useChatSharedQuery({ shareId: id || "" });
  const bottomRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // 메시지 DOM 참조 수집용: index 기준으로 매핑
  const messageRefs = useRef<Record<number, HTMLDivElement | null>>({});

  function handleItemMount(
    _message: Message,
    index: number,
    el: HTMLDivElement | null
  ) {
    messageRefs.current[index] = el;
  }

  function scrollToMessage(_target: Message, index: number) {
    // 사용자 메시지 목록에서의 index이므로, 전체 messages에서 같은 순서의 사용자 메시지의 실제 index를 찾아야 함
    const allMessages = messages ?? [];
    let userCounter = -1;
    let absoluteIndex = -1;
    for (let i = 0; i < allMessages.length; i++) {
      if (allMessages[i].messageType === "USER") {
        userCounter += 1;
        if (userCounter === index) {
          absoluteIndex = i;
          break;
        }
      }
    }
    if (absoluteIndex < 0) return;
    const el = messageRefs.current[absoluteIndex];
    el?.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  return (
    <div
      className="flex "
      style={{
        background:
          "radial-gradient(50.44% 50.44% at 50.87% 49.25%, #C7EFEB 0%, #FFF 100%)",
      }}
    >
      <main className="relative w-full h-[calc(100vh-70px)] pt-[64px] overflow-y-auto">
        {/* container-type 은 답변 표가 채팅 페인 폭을 알기 위한 기준점. 안에 fixed 요소를 두면 기준이 바뀌니 portal 로 뺀다.
            data-table-pane 은 넓은 표가 스크롤로 넘어갈 수 있는 왼쪽 끝의 기준이다(TableScrollBox) */}
        <div
          data-table-pane=""
          className="flex flex-col items-center min-h-full [container-type:inline-size]"
        >
          <MessageList messages={messages} onItemMount={handleItemMount} />
          <div ref={bottomRef} />
          <MessageNav
            messages={
              messages?.filter((msg: Message) => msg.messageType === "USER") ||
              []
            }
            onSelect={scrollToMessage}
          />
        </div>
      </main>
    </div>
  );
};

export default AiSharePage;
